import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { Maestros_CargasArchivosService } from 'src/app/services/maestros_cargasarchivos.service';
import { Maestro_Aliados } from '../../models/generic/Maestro_Aliados';
import { Item_Seleccion } from 'src/app/models/generic/Item_Seleccion';
import { Maestro_CargaRecurrenteArchivosTitulos } from 'src/app/models/generic/Maestro_CargaRecurrenteArchivosTitulos';
import { Maestro_CargaRecurrenteArchivosBeneficiarios } from '../../models/generic/Maestro_CargaRecurrenteArchivosBeneficiarios';
import { Maestro_CargaRecurrenteArchivosBeneficiariosCampos } from 'src/app/models/generic/Maestro_CargaRecurrenteArchivosBeneficiariosCampos';
import { AdicionarItemsListaAdicionalesComponent } from '../adicionar-items-lista-adicionales/adicionar-items-lista-adicionales.component';
import { Maestro_CargaApiClientesAsegurados } from 'src/app/models/generic/Maestro_CargaApiClientesAsegurados';
import { Maestros_CargaApiClientesAseguradosService } from '../../services/maestros_cargaapiclientesasegurados.service';

@Component({
  selector: 'maestros-cargaapiclientesasegurados-editar',
  templateUrl: './maestros-cargaapiclientesasegurados-editar.component.html',
  styleUrls: ['./maestros-cargaapiclientesasegurados-editar.component.scss']
})
export class MaestrosCargaApiClientesAseguradosEditarComponent implements OnInit{
  TIPOEDICION_COLUMNA_VISUALIZAR = 'COLUMNAS_VISUALIZAR';
  TIPOEDICION_COLUMNA_BENEFICIARIOS = 'COLUMNAS_BENEFICIARIOS';

  form: FormGroup;
  tituloForma: string = 'Registro de configuración';
  tituloBoton: string = 'Registrar configuración';
  mostrarCargando: boolean = false;
  listaDatosAplicaciones: Maestro_Aliados[] = [];
  parametrosPrincipal: Maestro_CargaApiClientesAsegurados;
  codigoAccion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('appvaloresposiblesmodal', {static: false}) _appvaloresposiblesmodal: AdicionarItemsListaAdicionalesComponent;
  listaEstado: Maestro_EstadoActualizar[] = [];
  _EditarItemsVisualizar: string = '';
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_CargaApiClientesAseguradosService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.listaEstado = [];

    this.listaEstado.push({ seleccionado: true, descripcion: 'Si' });
    this.listaEstado.push({ seleccionado: false, descripcion: 'No' });
  }
  ItemExtensionRetorno(id: string, descripcion: string): Item_Seleccion {
    let itemRetorno: Item_Seleccion = new Item_Seleccion();
    itemRetorno.id = id;
    itemRetorno.descripcion = descripcion;
    return itemRetorno;
  }
  ngAfterViewInit() {
    if (this.utilitariosService.VerificarContieneDatos(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);

      // console.log('setea valor', this.parametrosPrincipal);
      this.form.setValue(this.parametrosPrincipal);
      
      this.tituloForma = 'Edición de ruta';
      this.tituloBoton = 'Editar ruta';
    } else {
      this.tituloForma = 'Registro de ruta';
      this.tituloBoton = 'Registrar ruta';
    }
    this.ConsultarRegistrosAplicaciones();
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      id: [0],
      configuracionActiva: [true],
      aplicacion: [null, [Validators.required]],
      clienteCarga: ['', [Validators.required]],
      archivoCarga: ['', [Validators.required]],
      archivoProducto: ['', [Validators.required]],
      columnaIdentificacion: ['', [Validators.required]],
      columnaNombre: ['', [Validators.required]],
      columnaRegistroUnico: [''],
      columnaFechaInicial: ['', [Validators.required]],
      columnaFechaFinal: ['', [Validators.required]],
      columnasVisualizar: [''],
      mostrarBeneficiarios: [false],
      columnasBeneficiarios: [''],
      columnaApellido: [''],
      rutaTerminosCondiciones: ['']
    });
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosCargaApiClientesAseguradosComponent');
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      }
    }
  }
  Guardar() {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ActualizarRegistro() {
    this.mostrarCargando = true;

    this.datosServices.Actualizar(this.form.value)
            .subscribe((resp: RespuestaGenerica) =>{
              this.mostrarCargando = false;
              if (resp.procesoExitoso == false) {
                this.utilitariosService.MensajeToast(resp.mensaje);
              } else {
                this.menuService.CambiarComponenteActivo('MaestrosCargaApiClientesAseguradosComponent');
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  ConsultarRegistrosAplicaciones() {
    this.mostrarCargando = true;
    let parametrosConsulta: FormGroup = new FormGroup({
      'filtro': new FormControl('')
    });
    this.datosServices.Aplicaciones_Consultar(parametrosConsulta.value)
              .subscribe((resp: Maestro_Aliados[]) =>{
                this.mostrarCargando = false;
                this.listaDatosAplicaciones = resp;
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  SeleccionoValoresPosibles(valoresPosibles: string) {
    if (this._EditarItemsVisualizar === this.TIPOEDICION_COLUMNA_VISUALIZAR) {
      let listaCargas: Maestro_CargaRecurrenteArchivosTitulos[] = [];
      let itemsFilas = valoresPosibles.split('|');
      for (let index = 0; index < itemsFilas.length; index++) {
        let item = itemsFilas[index].split('*');
        listaCargas.push({ campo: item[0], titulo: item[1] });
      }

      this.form.get('columnasVisualizar').setValue(JSON.stringify(listaCargas));
    } else if (this._EditarItemsVisualizar === this.TIPOEDICION_COLUMNA_BENEFICIARIOS) {
      let listaCargas: Maestro_CargaRecurrenteArchivosBeneficiarios[] = [];
      let itemsFilas = valoresPosibles.split('|');
      for (let index = 0; index < itemsFilas.length; index++) {
        let item = itemsFilas[index].split('*');
        let itemsColumnas = item[1].split('&');
        let listaColumnas: Maestro_CargaRecurrenteArchivosBeneficiariosCampos[] = [];
        for (let index = 0; index < itemsColumnas.length; index++) {
          listaColumnas.push({ campo: itemsColumnas[index] });
        }

        listaCargas.push({ titulo: item[0], columnas: listaColumnas });
      }

      this.form.get('columnasBeneficiarios').setValue(JSON.stringify(listaCargas));
    }
  }
  EditarParametroValoresPosiblesAdicionalesVisualizar() {
    let listaCargas: Maestro_CargaRecurrenteArchivosTitulos[] = [];
    let itemsModificar: string = '';

    if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('columnasVisualizar').value)) {
      listaCargas = JSON.parse(this.form.get('columnasVisualizar').value)
    }

    for (let index = 0; index < listaCargas.length; index++) {
      if (itemsModificar === '') {
        itemsModificar = `${listaCargas[index].campo}*${listaCargas[index].titulo}`;
      } else {
        itemsModificar += `|${listaCargas[index].campo}*${listaCargas[index].titulo}`;
      }
    }
    
    this._EditarItemsVisualizar = this.TIPOEDICION_COLUMNA_VISUALIZAR;
    this._appvaloresposiblesmodal.MostrarEdicionItemsListaConAdicionales(itemsModificar, '|', '*', true, false);
  }
  EditarParametroValoresPosiblesColumnasBeneficiarios() {
    let listaCargas: Maestro_CargaRecurrenteArchivosBeneficiarios[] = [];
    let itemsModificar: string = '';

    if (this.utilitariosService.VerificarContieneDatosTexto(this.form.get('columnasBeneficiarios').value)) {
      listaCargas = JSON.parse(this.form.get('columnasBeneficiarios').value)
    }

    for (let index = 0; index < listaCargas.length; index++) {
      let itemTitulo = listaCargas[index];
      let columnasAdicionar: string = '';
      for (let index2 = 0; index2 < itemTitulo.columnas.length; index2++) {
        let itemColumna = itemTitulo.columnas[index2].campo;
        
        if (columnasAdicionar === '') {
          columnasAdicionar = itemColumna;
        } else {
          columnasAdicionar += `&${itemColumna}`;
        }
      }
      if (itemsModificar === '') {
        itemsModificar = `${itemTitulo.titulo}*${columnasAdicionar}`;
      } else {
        itemsModificar += `|${itemTitulo.titulo}*${columnasAdicionar}`;
      }
    }

    this._EditarItemsVisualizar = this.TIPOEDICION_COLUMNA_BENEFICIARIOS;
    this._appvaloresposiblesmodal.MostrarEdicionItemsListaConAdicionales(itemsModificar, '|', '*', false, true);
  }
}
